<template>
  <div class="card flex-column compete-purchase-list">
    <base-section-title>
      <span>
        在线供应商
        <span v-if="lists.length">
          （<label class="text-success">{{ onlineNum }}</label>/{{ lists.length }}）
        </span>
      </span>
    </base-section-title>

    <div class="list-content">
      <div v-if="!lists.length" class="no-list flex-center">暂无相关数据</div>

      <el-scrollbar v-else>
        <div class="list-wrap">
          <div
            v-for="list in lists"
            :key="list.supplierId"
            class="list flex-align__between"
          >
            <div class="text-ellipsis">
              {{ list.supplierName }}
            </div>
            <el-tag
              :type="Number(list.online) ? 'success' : 'info'"
              size="medium"
            >
              {{ Number(list.online) ? '在线' : '离线' }}
            </el-tag>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'

export default {
  name: 'CompetePurchaseList',

  components: { BaseSectionTitle },

  props: {
    lists: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    onlineNum() {
      return this.lists.filter(value => {
        return value.online == 1
      }).length
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.compete-purchase-list {
  width: 100%;
  height: 100%;
  padding-bottom: pixel-to-rem($n: 40);

  .list-content {
    flex: 1;
    overflow: hidden;

    .no-list {
      height: 100%;
      margin: 0 pixel-to-rem($n: 20);
      background-color: $grey-background-color;
      font-size: pixel-to-rem($n: 22);
      color: $third-text-color;
    }

    ::v-deep .el-scrollbar {
      height: 100%;

      .el-scrollbar__wrap {
        overflow-x: hidden !important;
      }
    }

    .list-wrap {
      padding: 0 pixel-to-rem($n: 20);

      .list {
        padding: pixel-to-rem($n: 15) 0;

        .text-ellipsis {
          flex: 1;
          margin-right: pixel-to-rem($n: 10);
          font-size: pixel-to-rem($n: 20);
        }
      }
    }
  }
}
</style>
